/** Format a knots value into the chosen unit.
 *
 * Matches the web source's return shape exactly: returns the literal string
 * `'0'` when input is falsy, and a rounded number otherwise. The union return
 * type is load-bearing — call sites template-string this directly and the
 * `'0'` fallback has shipped for years; changing it would surface as subtle
 * render diffs. */
export function formatSpeed(
  knots: number | null | undefined,
  unit: 'kmh' | 'mph' | 'kn' = 'kmh',
): string | number {
  if (!knots) return '0';
  const conversions: Record<'kmh' | 'mph' | 'kn', number> = {
    kmh: 1.852,
    mph: 1.15078,
    kn: 1,
  };
  return Math.round(knots * (conversions[unit] ?? 1.852));
}
